"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLingeringFlag = useLingeringFlag;
var react_1 = require("react");
function useLingeringFlag(value, delay) {
    if (delay === void 0) { delay = 250; }
    var _a = (0, react_1.useState)(value), isLingering = _a[0], setIsLingering = _a[1];
    (0, react_1.useEffect)(function () {
        if (value) {
            setIsLingering(true);
            return;
        }
        var timer = setTimeout(function () { return setIsLingering(false); }, delay);
        return function () { return clearTimeout(timer); };
    }, [value, delay]);
    return value || isLingering;
}
